import { render, staticRenderFns } from "./TaskTodo.vue?vue&type=template&id=67c340c9&"
import script from "./TaskTodo.vue?vue&type=script&lang=js&"
export * from "./TaskTodo.vue?vue&type=script&lang=js&"
import style0 from "./TaskTodo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports